import L from 'leaflet';

export function addLayerControl(
    map: L.Map,
    baseLayers: Record<string, L.Layer>,
    overlays: Record<string, L.Layer>
) {
    const layerControl = L.control.layers(baseLayers, overlays, {
        position: 'topright'
    }).addTo(map);

    // Add a custom label to the layer control
    const container = layerControl.getContainer();
    if (container) {
        const label = L.DomUtil.create('div', 'map-data-label');
        label.innerHTML = 'Map Data';
        container.prepend(label);
    }
}
